import React from 'react'
import IssuesGrid from '../../../components/entities/IssuesGrid'
import useFetchEntitiesWithCache from '../../../hooks/useFetchEntitiesWithCache'
import { NewsItem } from 'types/NewsItem'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'

const GridWrapper = ({ children, isLoading }: { children: React.ReactNode; isLoading: boolean }) => (
    <div style={{ display: 'flex', flexDirection: 'column', height: isLoading ? 257 : undefined }}>{children}</div>
)

const sortNews = (a: NewsItem, b: NewsItem) => {
    if (a.publicationDate === null) return 0
    if (b.publicationDate === null) return 0

    return new Date(b.publicationDate).getTime() - new Date(a.publicationDate).getTime()
}

export const IssuesNews = ({ isSlim }: { isSlim: boolean }) => {
    const { isLoading: isLoadingIssues, result: issues } = useFetchEntitiesWithCache('issue')
    const { isLoading: isLoadingNews, result: news } = useFetchEntitiesWithCache('news')

    const latestPublishedIssues =
        news
            ?.filter((n) => n.eventType === 'publication')
            .sort(sortNews)
            .map((n) => issues?.find((i) => i.id === n.entityId))
            .filter((i) => !!i)
            .slice(0, 6) || []

    const latestPublishedIssueOutcomes =
        news
            ?.filter(
                (n) =>
                    ['outcome', 'preliminary outcome'].includes(n.eventType) && n.entityType !== 'ABB Directed issue',
            )
            .sort(sortNews)
            .map((n) => issues?.find((i) => i.id === n.entityId))
            .filter((i) => !!i)
            .slice(0, 6) || []

    const isLoadingIssuesOrNews = isLoadingIssues || isLoadingNews

    return (
        <Grid container spacing={2}>
            <Grid
                size={{ xs: 12, lg: 6 }}
                sx={{
                    alignItems: 'stretch',
                }}
            >
                <Card sx={{ height: '100%' }}>
                    <CardContent>
                        <Typography variant='h6' sx={{ paddingBottom: 4 }}>
                            Senaste aviserade emissionerna
                        </Typography>

                        <GridWrapper isLoading={isLoadingIssuesOrNews}>
                            <IssuesGrid
                                fields={['issueLabel', 'offeredSize', !isSlim && 'totalCommitment']}
                                hideFooter
                                isCompact
                                isLoading={isLoadingIssuesOrNews}
                                issues={latestPublishedIssues}
                                pagination={false}
                            />
                        </GridWrapper>
                    </CardContent>
                </Card>
            </Grid>
            <Grid
                size={{ xs: 12, lg: 6 }}
                sx={{
                    alignItems: 'stretch',
                }}
            >
                <Card sx={{ height: '100%' }}>
                    <CardContent>
                        <Typography variant='h6' sx={{ paddingBottom: 4 }}>
                            Senaste avslutade företrädesemissionerna
                        </Typography>

                        <GridWrapper isLoading={isLoadingIssuesOrNews}>
                            <IssuesGrid
                                fields={['issueLabel', 'subscribedSize', !isSlim && 'outcome']}
                                hideFooter
                                isCompact
                                isLoading={isLoadingIssuesOrNews}
                                issues={latestPublishedIssueOutcomes}
                                pagination={false}
                            />
                        </GridWrapper>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}
